
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quelle est son efficacité?`}</em></p>
    <p>{`A fin décembre, `}<a parentName="p" {...{
        "href": "499442998506"
      }}>{`Sinopharm a annoncé une efficacité de 79,34%`}</a>{`.
`}<a parentName="p" {...{
        "href": "https://www.who.int/fr/news-room/feature-stories/detail/the-sinopharm-covid-19-vaccine-what-you-need-to-know"
      }}>{`L'OMS`}</a>{`
a confirmé cette efficacité de 79% contre une infection symptomatique et contre
l'hospitalisation. Elle précise que l'essai n'a pas été conçu de manière à
pouvoir démontrer l'efficacité contre la maladie grave chez les personnes
présentant des comorbidités, les femmes enceintes ou les personnes de 60 ans et
plus. Deux autres essais sont en cours, dont les données ne sont pas encore
disponibles. L'OMS ajoute que ce vaccin n'a "pas encore été évalué dans le
contexte de la circulation étendue de variants préoccupants".`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;